import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// import axios from "./config/axios.js";


createApp(App).use(router).mount("#app");

